import React, { useState } from 'react';
import { Row, Col, Card} from 'antd';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import Button from '@mui/material/Button';
import PlaceHolder from '../../components/Placeholder';
import { createPortfolioPath } from '../../api/pathApi';
import PathCard from './PathCard';
import {updatePortfolioPath} from "../../api/pathApi";
import NavTrail from "../../layouts/NavTrail";
import {SaveRounded} from "@mui/icons-material";
import useClipboard from "../../hooks/useClipboard";
import PathList from "./PathList";
import useCompany from '../Company/useCompany';


const PathCollection = ({paths, onEdit})=>{
    return (
        <div className={'flex flex-col'}>
            {paths.map((path)=>(
                <PathCard path={path} onEdit={()=>onEdit(path)}/>
            ))}
        </div>
    )
}


const PortfolioPaths = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const portfolioPaths = useSelector(state=>state.user.data?.path_details??[]);
    const [currentPath, setCurrentPath] = useState(null);
    const [view, setView] = useState('list');

    const onCreateNewPath = ()=>{
        navigate('/portfolios/paths/new/edit')
        // setCurrentPath(null);
        // setView('editor');
    }

    const onEditPath = (path)=>{
        navigate(`/portfolios/paths/${path.id}/edit`)
        // setCurrentPath(path)
        // setView('editor');
    }

    const handleSave = () => {
        setView('list'); // Return to list view after save
      };



    return (
        <>
            <div className="sticky top-0 bg-white z-50 border-b bordered py-4 px-8" style={{width: '100%'}}>
                <NavTrail items={[{label: 'Portfolio Paths'}]}
                          extraLeft={(
                              <Button className={'pill'} onClick={onCreateNewPath} variant={'contained'} size={'large'}>
                                  Create New Path
                              </Button>
                          )}
                />
            </div>
            {view === 'list' && (
                <div className={'xs:p-4 lg:p-6 xl:p-12 py-6 mx-auto 2xl:max-w-[70vw]'}>
                    <PathList paths={portfolioPaths} onEdit={onEditPath}/>

                </div>
            )}
        </>
    )
}


export default PortfolioPaths;